<template>
  <section class="content">
    <div id="overlay"  v-if="loading">
      <div class="spinner"></div>
      <br/>
        <h4>Loading...</h4>
    </div>
      <div class="box box-info">

        <form>
          <div class="p-fluid p-formgrid p-grid p-mt-2">
              <div class="p-field p-col-12 p-md-2">
                <label for="purchaseSalesDate">Order Date</label>
                <date-picker ref="tran" v-model="purchaseSalesDate" valueType="format" v-if="!englishDateEnabled"/>
                <InputMask mask="9999-99-99" type="text" ref="tran" v-else class="nepali-calendar" id="purchaseSalesDate" v-model="purchaseSalesDate"/>
              </div>

              <div class="p-field p-col-12 p-md-2">
                <label for="orderNo">Order No</label>
                <InputText id="orderNo"  disabled v-model="orderNo"/>
              </div>
              <div class="p-field p-col-12 p-md-2">
                <label for="referenceNumber" >Ref No</label>
                <InputText id="referenceNumber"  v-model="referenceNumber"/>
              </div>


              <div class="p-field p-col-12 p-md-2">
                <label for="warehouse">Store</label>
                <Dropdown
                  v-if="!setWarehouseData"
                  v-model="warehouseId"
                  :options="warehouseLists"
                  optionLabel="name"
                  id="warehouse"
                  :filter="true"
                  placeholder="Select warehouse"
                  :showClear="true"
                />
                <Dropdown
                  v-if="setWarehouseData"
                  v-model="warehouseId"
                  :options="warehouseLists"
                  optionLabel="name"
                  id="warehouse"
                  :filter="true"
                  placeholder="Select warehouse"
                  :disabled="true"
                />
              </div>
              <wearhouseDialog class="p-mt-5" v-tooltip.top="'Add Warehouse'" @set_data_warehouse="set_data_warehouse"/>
            </div>
            <div class="p-fluid p-formgrid p-grid p-mt-2">
                <div class="p-field p-col-12 p-md-4">
                  <label for="party" >Order From</label>
                  <Dropdown
                  v-model="accountMasterId"
                  :options="supplierAndCustomerList"
                  optionLabel="name"
                  class="dropDown"
                  :filter="true"
                  placeholder="Select Vendor"
                  :showClear="true"
                />
              </div>
              <supplierDialog class="p-mt-5" v-tooltip.top="'Add Supplier'" @set_supplier_master="set_supplier_master"/>

              <div class="p-field p-col-12 p-md-2 p-mt-5" v-if="accountMasterId.id>0">
               <label for="panNo">Closing Balance</label>
               <b style="margin-left:20px;color:red;" v-if="accountMasterId.closingBalance>0">{{(accountMasterId.closingBalance).toFixed(2) +'Cr'}}</b>
               <b v-else style="margin-left:20px;color:green;">{{(accountMasterId.closingBalance*(-1)).toFixed(2) +'Dr'}}</b>
              </div>
<!--              <div class="col-md-2 address" v-if="accountMasterId.id>0">-->
<!--                 <label for="address">Contact Name</label>-->
<!--                <b>{{accountMasterId.contactName}}</b>-->
<!--              </div>-->
              <div class="p-field p-col-12 p-md-2 p-mt-5" v-if="accountMasterId.id>0" >
                <label for="panNo">Pan No</label>
                <b>{{accountMasterId.panNo}}</b>
              </div>
            </div>
            <div class="p-fluid p-formgrid p-grid p-mt-2">
                <div class="p-field p-col-12 p-md-2">
                  <label for="item">Item<b style="color:red;">*</b></label>
                <!-- <Dropdown
                  v-model="items"
                  :options="itemMasterListByItemType"
                  optionLabel="name"
                  class="dropDown"
                  :filter="true"
                  placeholder="Select Item"
                /> -->
                  <AutoComplete v-model="items" filterMatchMode='contains'
                 :suggestions="filteredItems" @complete="searchItem($event)"
                  field="name" ref="itm">
                    <template #item="slotProps">
                      <div style="font-size: 12px !important;">{{ slotProps.item.name }} - {{ slotProps.item.itemCode }}</div>
                    </template>
                 </AutoComplete>
              </div>
              <div class="p-field p-col-12 p-md-1 align-self-end">
              <itemDialog style="margin-top:1.3em;margin-right: -10em;" v-tooltip.top="'Add Item'" @set_data_item="set_data_item"/>
              </div>
              <div class="p-field p-col-12 p-md-2">
                <label for="quantity">Quantity</label>
                <!-- <input type="text" class="form-control" @keypress="isNumber(event)" id="quantity" v-model="quantity" /> -->
              <InputNumber id="quantity" v-model="quantity" onfocus="if (this.value === '0.00')
                                this.value = ''" :minFractionDigits="2" :maxFracionDigits="4" />
              </div>
                <div class="p-field p-col-12 p-md-1">
                <label for="qty">Unit</label>
               <InputText v-model="items.unitName" disabled/>
              </div>
                <div class="p-field p-col-12 p-md-2">
                <label for="rate">Rate</label>
                <!-- <input type="text" class="form-control" @keypress="isNumber(event)" id="rate" v-model="rate" /> -->
              <InputNumber id="rate" v-model="rate" onfocus="if (this.value === '0.00')
                                this.value = ''"  :minFractionDigits="2" :maxFracionDigits="4" />
              </div>
              <div class="p-field p-col-12 p-md-2">
                <label  for="total" >Total</label>
                <!-- <input  class="form-control" id="total" @keypress="isNumber(event)"  v-model="total"/> -->
              <InputNumber disabled  id="total" onfocus="if (this.value === '0.00')
                                this.value = ''" v-model="total"  :minFractionDigits="2" :maxFracionDigits="4" />
              </div>

                <div class="p-field p-col-12 p-md-1 p-mt-5">
                  <Button type="submit" class="p-button p-component addNewBtn btn-btm-0" @click.prevent="addItemToDTO"
                  :label="!editDto?'Add':'Update'"/>
                </div>
                <div class="p-field p-col-12 p-md-1 p-mt-5">
                <Button class="p-button-raised p-button-danger" v-if="editDto"
                        @click="itemDTOreset"
                label="Cancel"/>
              </div>
            </div>
            <div style="display:none">{{findRate}}{{totalAmount}}{{setRateFromItem}}</div>
                <div class="p-field p-col-12 p-md-2" v-if="items.closingStock>=0">
                <label for="avlQty">Cur. Stock: </label>
                <span>{{items.closingStock}}{{items.unitName}}</span>
              </div>
        </form>
        <div class="p-field p-col-12 p-md-12">
          <div >
            <div class="scrollable">
              <table class="table table-bordered ">
                <thead >
                  <tr>
                    <th >SN</th>
                    <th >Item Name</th>
                    <th >Quantity</th>
                    <th >Rate</th>
                    <th >Amount</th>
                    <th >Action</th>
                  </tr>
                </thead>
                <tbody  v-for="(item,index) in inventoryInOutDetailList " :key="index">
                  <tr>
                    <td>{{index+1}}</td>
                    <td>{{item.itemMaster.name}}</td>
                    <td>{{item.quantity}}</td>
                    <td>{{item.rate}}</td>
                    <td>{{item.rate * item.quantity}} </td>
                    <td>
                      <Button class="p-button-raised p-button-success" @click.prevent="editFromDto(item,index)" icon="pi pi-pencil"/>
                      <Button icon="pi pi-trash" class="p-button-raised p-button-danger" v-if="editDto" @click="deleteItemFromDTO(item, index)" disabled/>
                      <Button icon="pi pi-trash" class="p-button-raised p-button-danger" v-else-if="!editDto" @click="deleteItemFromDTO(item, index)" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <hr>
            <div class="p-fluid p-formgrid p-grid p-mt-2">
                <div class="p-field p-col-12 p-md-2">
                  <b style="margin-left: 15em;">Total:</b>
                </div>
                <div class="p-field p-col-12 p-md-2">
                  <b style="margin-left: 20em;">{{totalQty}}</b>
                </div>
                <div class="p-field p-col-12 p-md-2">
                  <b style="margin-left: 38em;">{{subTotal}}</b>
                </div>
              </div>
           <hr>
          </div>
        </div>
        <div class="p-fluid p-formgrid p-grid">
           <div class="p-field p-col-12 p-md-4">
            <label >Narration</label>
            <Textarea rows="6" v-model="narration"/>
          </div>
        </div>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-6"></div>
          <div class="p-field p-col-12 p-md-1">
            <Button icon="pi pi-save" class="p-button-raised p-button-success"
             @click.prevent="savePurchaseOrder" :label="purchaseOrder === undefined ? 'Save': 'Update'"/>
           </div>
           <div class="p-field p-col-12 p-md-1">
             <Button class="p-button-raised p-button-warning" @click="reset"
             v-if="this.purchaseOrder === undefined" label="Reset" icon="pi pi-refresh"/>
           </div>
           <div class="p-field p-col-12 p-md-1" v-if="this.purchaseOrder!=undefined">
            <Button  class="p-button-raised p-button-danger"
            @click="goBack()" label="Cancel"/>
          </div>

           <div class="p-field p-col-12 p-md-1">
            <Button class="p-button-raised p-button-secondary" label="Print" icon="pi pi-print"/>
          </div>
          <div class="p-field p-col-12 p-md-2">
            <Button class="p-button-raised p-button-secondary" label="Generate PDF" icon="pi pi-download"/>
          </div>
        </div>
      </div>
  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import DatePicker from 'vue2-datepicker'
import $ from 'jquery'
import AutoComplete from 'primevue/autocomplete'
import InputNumber from 'primevue/inputnumber'
import InputMask from 'primevue/inputmask'
import supplierDialog from '../accountDialog/SupplierAccountDialog'
import wearhouseDialog from '../warehouseDialog/warehouseDialog'
import itemDialog from '../itemDialog/itemMasterDialog'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Textarea from 'primevue/textarea'
export default {
  name: 'purchaseOrder',
  props: ['purchaseOrder'],
  data() {
    return {
      name: '',
      warehouseId: '',
      accountMasterId: '',
      a: '',
      referenceNumber: '',
      quantity: 0,
      orderMessage: '',
      rate: 0,
      purchaseSalesDate: null,
      inventoryInOutDetailList: [],
      inventoryInOutDetailDeleteList: [],
      editing: false,
      editDto: false,
      index: null,
      orderNo: null,
      inventoryHeaderId: null,
      loading: true,
      id: null,
      totalQty: '',
      total: 0,
      filteredItems: null,
      englishDateEnabled: true,
      items: '',
      narration: '',
      setWarehouseData: false
    }
  },
  computed: {
    amount() {
      return parseFloat(this.quantity) * parseFloat(this.rate)
    },
    totalAmount() {
      if (this.quantity > 0 && this.rate > 0) {
        let totalAmt = 0
        totalAmt = parseFloat(this.quantity) * parseFloat(this.rate).toFixed(2)
        if (isNaN(totalAmt)) {
          totalAmt = 0
        }
        this.total = totalAmt
        return totalAmt
      }
    },
    findRate() {
      let rates = 0
      if (this.rate === 0) {
        if (this.total > 0 && this.quantity > 0) {
          rates = this.total / this.quantity
          this.rate = rates.toFixed(2)
        }
        if (isNaN(rates)) {
          rates = 0
        }
      }
      return rates
    },
    setRateFromItem() {
      if (!this.editDto) {
        let rate = 0
        this.rate = this.items.purchaseRate
        return rate
      }
    },
    subTotal() {
      let subTotal = 0
      this.taxable = 0
      this.tax = 0
      this.nonTaxable = 0
      this.totalQty = 0
      for (let i = 0; i < this.inventoryInOutDetailList.length; i++) {
        subTotal += (parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity))
        this.itemSelected = this.inventoryInOutDetailList[i].itemMaster
        this.totalQty += parseFloat(this.inventoryInOutDetailList[i].quantity)
      }
      return subTotal
    },
    warehouseLists() {
      return this.$store.state.warehouse.warehouseDropDownList
    },
    supplierAndCustomerList() {
      return this.$store.state.accountMaster.supplierAndCustomerList
    },
    itemMasterListByItemType() {
      return this.$store.state.itemMaster.itemMasterListByItemType
    },
    totalBillAmount() {
      let totalBillAmount = 0
      for (let i = 0; i < this.inventoryInOutDetailList.length; i++) {
        totalBillAmount += parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity)
      }
      return totalBillAmount
    }

  },
  mounted() {
    const promises = [
      this.warehouseList(),
      this.supplierCustomerList(),
      this.itemMasterListByItemTypes(),
      this.maxPurchaseOrderNo()
    ]
    if (this.purchaseOrder !== undefined) {
      promises.push(this.editPurchaseOrder())
    }
    Promise.all(promises)
      .then(() => {
        this.loading = false
      })
      .catch(() => {
        this.loading = false
        this.$toast.add({
          severity: 'error',
          summary: '',
          detail: 'Failed to load data',
          life: 10000
        })
      })
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.purchaseOrder === undefined ||
        this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.setWarehouse()
  },
  methods: {
    async warehouseList() {
      await this.$store.dispatch('loadWarehouseDropDown')
    },
    async supplierCustomerList() {
      await this.$store.dispatch('loadsupplierAndCustomerList')
    },
    async itemMasterListByItemTypes() {
      await this.$store.dispatch('loadItemMasterListByItemTypePurchase')
    },
    async maxPurchaseOrderNo() {
      let response = await this.$store.dispatch('maxPurchaseOrderNo')
      if (this.purchaseOrder === undefined) {
        this.orderNo = response.data.data
        this.orderMessage = response.data.message
        this.narration = response.data.message + '- ' + response.data.data
      } else {
        this.orderNo = this.purchaseOrder.orderNo
        this.orderMessage = this.purchaseOrder.remarks
      }
    },
    setWarehouse() {
      if (this.$store.state.warehouseData.id > 0) {
        this.setWarehouseData = true
        this.warehouseId = this.$store.state.warehouseData
      } else if (this.warehouseLists.length === 1) {
        this.warehouseId = this.warehouseLists[0]
      }
    },
    addItemToDTO() {
      let item = {
        itemId: this.items.id,
        itemMaster: this.items,
        quantity: this.quantity,
        rate: this.rate,
        id: this.id
      }
      if (this.warehouseId === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select store!', life: 10000})
        return
      }
      if (this.accountMasterId === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select vendor!', life: 10000})
        return
      }
      if (this.items.id === undefined) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Invalid item!', life: 10000})
        return
      }
      if (this.items === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select at least one item!', life: 10000})
        return
      } else if (this.quantity <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Quantity must be greater than 0!', life: 10000})
        return
      } else if (this.rate <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Rate must be greater than 0!', life: 10000})
        return
      } else {
        if (!this.editDto) {
          this.inventoryInOutDetailList.push({...item})
        } else {
          this.inventoryInOutDetailList.splice(this.index, 1, {...item})
        }
      }
      this.itemDTOreset()
      this.focusInput()
    },
    async savePurchaseOrder() {
      if (this.purchaseSalesDate === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select purchase date!', life: 10000})
        return
      }
      let response = ''
      let purchaseOrder = {
        orderNo: this.orderNo,
        warehouseId: this.warehouseId.id,
        accountMasterId: this.accountMasterId.id,
        purchaseSalesDate: this.purchaseSalesDate,
        purchaseSalesDateNepali: this.purchaseSalesDate,
        referenceNumber: this.referenceNumber,
        fiscalYearId: this.$store.state.fyId,
        totalBillAmount: this.totalBillAmount,
        remarks: this.narration,
        inventoryHeaderId: this.inventoryHeaderId,
        inventoryInOutDetailList: this.inventoryInOutDetailList,
        inventoryInOutDetailDeleteList: this.inventoryInOutDetailDeleteList
      }
      if (purchaseOrder.inventoryInOutDetailList.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please add one item!', life: 10000})
        return
      }
      if (!this.editing) {
        this.loading = true
        response = await this.$store.dispatch('addpurchaseOrder', purchaseOrder)
        this.loading = false
      } else {
        this.loading = true
        response = await this.$store.dispatch('updatePurchaseOrder', purchaseOrder)
        this.loading = false
        this.$router.go(-1)
      }
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        await this.maxPurchaseOrderNo()
        this.reset()
        if (!this.editing) {
          this.focusAfterSave()
        }
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      }
    },
    editFromDto(data, index) {
      this.itemDTOreset()
      this.editDto = true
      this.items = data.itemMaster
      this.rate = data.rate
      this.quantity = data.quantity
      this.total = (parseFloat(data.rate) * parseFloat(data.quantity)).toFixed(2)
      this.index = index
      if (data.id !== undefined) {
        this.id = data.id
      }
    },
    set_data_warehouse(data) {
      let warehouse = {
        id: data.id,
        name: data.name
      }
      this.warehouseId = warehouse
      this.warehouseList()
    },
    set_data_item(data) {
      this.items = data
      this.itemMasterListByItemTypes()
    },
    set_supplier_master(data) {
      this.supplierCustomerList()
      this.accountMasterId = data
    },
    editPurchaseOrder() {
      this.editing = true
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.purchaseSalesDate = this.purchaseOrder.purchaseSalesDateNepali
      } else {
        this.purchaseSalesDate = this.purchaseOrder.purchaseDate
      }
      this.inventoryHeaderId = this.purchaseOrder.id
      this.narration = this.purchaseOrder.remarks
      this.referenceNumber = this.purchaseOrder.referenceNumber
      this.warehouseId = this.purchaseOrder.warehouse
      this.accountMasterId = this.purchaseOrder.accountMaster
      this.inventoryInOutDetailList = this.purchaseOrder.inventoryInOutDetailList
    },
    deleteItemFromDTO(data, index) {
      if (this.editing && data.id !== null) {
        this.inventoryInOutDetailDeleteList.push({...data})
      }
      this.inventoryInOutDetailList.splice(index, 1)
    },
    itemDTOreset() {
      this.items = ''
      this.rate = 0
      this.quantity = 0
      this.total = 0
      this.editDto = false
      this.id = null
    },
    reset() {
      this.itemDTOreset()
      this.warehouseId = ''
      this.accountMasterId = ''
      this.referenceNumber = ''
      this.editing = false
      this.inventoryInOutDetailList = []
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      } else {
        this.purchaseSalesDate = new Date().toISOString().slice(0, 10)
      }
    },
    isNumber(evt) {
      evt = window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    setNepaliDate() {
      if (this.purchaseOrder === undefined) {
        this.purchaseSalesDate = this.$store.getters.nepaliNewDate
      }
    },
    nepaliDate() {
      $('#purchaseSalesDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.purchaseSalesDate = $('#purchaseSalesDate').val()
        }
      })
    },
    searchItem(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.filteredItems = [...this.itemMasterListByItemType]
        } else {
          this.filteredItems = this.itemMasterListByItemType.filter((item) => {
            return item.name.toLowerCase().includes(event.query.toLowerCase()) || item.itemCode.includes(event.query)
          })
        }
      }, 250)
    },
    setEnglishDate() {
      this.purchaseSalesDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    focusInput() {
      this.$refs.itm.focus()
    },
    focusAfterSave() {
      this.$refs.tran.focus()
    },
    goBack() {
      if (this.inventoryInOutDetailDeleteList.length > 0) {
        this.purchaseOrder.inventoryInOutDetailList = this.inventoryInOutDetailDeleteList
      }
      this.$router.back()
    }
  },
  components: {
    Dropdown,
    DatePicker,
    AutoComplete,
    InputNumber,
    InputMask,
    supplierDialog,
    wearhouseDialog,
    itemDialog,
    InputText,
    Button,
    Textarea
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">
</style>



// WEBPACK FOOTER //
// purchaseorder.vue?8ba95b52